/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { IViewerSourceCreator } from '../../iframe'
 * @import { ViewerSourceFactory } from '../source'
 * @import PoolFactory from '../../pool/pool-factory'
 */

// TODO Unit testy.
/**
 * Poskytovatel zdrojů pro zobrazování HTML iframe elementů.
 * Implementuje návrhový vzor Object pool pro tvorbu zdrojů.
 * Provádí recyklaci vrácených zdrojů pro další použití.
 * @implements {IViewerSourceCreator}
 */
export default class ViewerSourceIframeCreator {
  /**
   * Vytvoří instanci.
   * @param {PoolFactory} poolFactory
   * @param {ViewerSourceFactory} sourceFactory Továrna na zdroje, které se poskytují.
   */
  constructor(poolFactory, sourceFactory) {
    this.pool = poolFactory.create(sourceFactory);
    this.sourceFactory = sourceFactory;
  }

  /** @type {IViewerSourceCreator['delete']} */
  delete(source) {
    return new Promise((resolve) => resolve(this.pool.delete(source)));
  }

  /** @type {IViewerSourceCreator['destroy']} */
  destroy() {
    this.pool.destroy();
  }

  /** @type {IViewerSourceCreator['getLent']} */
  getLent() {
    return this.pool.getLent();
  }

  /** @type {IViewerSourceCreator['getMax']} */
  getMax() {
    return this.pool.getMax();
  }

  /** @type {IViewerSourceCreator['isUsingVideoElement']} */
  isUsingVideoElement() {
    return false;
  }

  /** @type {IViewerSourceCreator['lend']} */
  lend(parentEl) {
    return new Promise((resolve) => {
      const { pool } = this;
      // Nastaví se rodičovský element továrny, aby do něj vytvářela nové zdroje.
      // Nastavuje se dopředu, aby byl rodičovský element dostupný v okamžiku plnění bazénu.
      this.sourceFactory.setParentEl(parentEl);
      // Vypůjčení zdroje z bazénu.
      const source = pool.lend();
      // Nastaví se rodičovský element továrny, aby do něj vytvářela nové zdroje.
      // Nastavuje se duplicitně, protože není jistota, že datový zdroj vytvoří továrna.
      // Může dojít k recyklaci a zdroj může mít nastaven starý rodičovský element.
      source.setParentEl(parentEl);
      return resolve(source);
    });
  }

  /** @type {IViewerSourceCreator['receive']} */
  receive(source) {
    return new Promise((resolve) => resolve(this.pool.delete(source)));
  }

  /** @type {IViewerSourceCreator['replace']} */
  replace() {
    // Není třeba nic provést.
    return Promise.resolve();
  }
}
